/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class FollowUpActions extends Fragment {
  @attr('boolean') answerBotEnabled;
  @attr('string') followUpReply;
  @attr('boolean') leadQualificationEnabled;
}
